import React from 'react';
import './Tag.css';
import { attributeTagNames } from '../../../models/tag_representations';

const ImpactAttributeTag = ({ attributeType, isButton, onButtonClick }) => {
    if (!attributeType) return null;

    return (
        <div>
            {isButton ? (
                <button className={`tag-button ${attributeType}`}>
                    {attributeTagNames[attributeType]}
                </button>
            ) : (
                <div className={`tag ${attributeType}`}>
                    {attributeTagNames[attributeType]}
                </div>
            )}
        </div>
    );
};

export default ImpactAttributeTag;
